export function getNumberOfFormLines(str, threshold = 90) {
  const numberOfLineBreaks = str ? (str.match(/\n/g) || []).length : 0
  const base = str ? Math.ceil(str.length / threshold) : 1
  return base + numberOfLineBreaks
}
